import { ChevronRight as ChevronRightIcon, User as UserIcon } from 'lucide-react'
import { type StudentResponse } from '../../lib/api'

interface SelectStudentProps {
  students: StudentResponse[]
  onSelect: (studentId: string) => void
}

export default function SelectStudent({ students, onSelect }: SelectStudentProps) {
  return (
    <div className="space-y-4">
      <p className="text-gray-600 text-center mb-6">
        Which child is this device for?
      </p>
      {students.map((student) => (
        <button
          key={student.id}
          onClick={() => onSelect(student.id)}
          className="w-full bg-white border-2 border-gray-200 rounded-xl p-4 hover:border-brand hover:shadow-md transition-all text-left"
        >
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-brand-light flex items-center justify-center flex-shrink-0">
              <UserIcon size={24} className="text-brand" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-gray-900 truncate">{student.name}</h3>
            </div>
            <ChevronRightIcon size={20} className="text-gray-400" />
          </div>
        </button>
      ))}
    </div>
  )
}
